import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["children", "tag", "type"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { CONTENT_TYPES } from "../constants";
import { contentVariantStyles } from "../variant-styles";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledContent = styled.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant;
  return variant && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", ";\n    "])), contentVariantStyles[variant]);
});

var Content = function Content(_ref2) {
  var children = _ref2.children,
      tag = _ref2.tag,
      type = _ref2.type,
      other = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_jsx(StyledContent, _objectSpread(_objectSpread({
    as: tag,
    variant: type
  }, other), {}, {
    children: children
  }));
};

Content.displayName = "Content";
Content.propTypes = {
  /** Adds any content between tags */
  children: PropTypes.node,

  /** Sets the content tag */
  tag: PropTypes.elementType,

  /** Sets the content styles. */
  type: PropTypes.oneOf(Object.values(CONTENT_TYPES))
};
Content.defaultProps = {
  children: null,
  tag: 'div',
  type: CONTENT_TYPES.BODY_1
};
export { Content };